export const h ={
    "common": {
        "webSuffix": "-QIDI Tech QIDI Technology",
        "email": "Поштова скринька",
        "password": "75950",
        "verificationCode": "Код перевірки",
        "username": "Ім'я користувача",
        "readAndAgree": "Я погоджуюсь",
        "and": "і",
        "userAgreement": "Угода користувача",
        "privacyPolicy": "Політика конфіденційності",
        "copy": "Авторське право © 2025 QIDI зберігає право власності",
        "sendVerificationCode": "Надіслати код перевірки",
        "Sending": "Направлення",
        "tryAgainInSeconds": "Спробуйте повторно через секунди",
        "userNameRequired": "Будь ласка, введіть ім'я користувача",
        "passwordInputLabel": "Будь ласка, введіть пароль",
        "checkPasswordInputLabel": "Будь ласка, введіть пароль підтвердження",
        "userEmailRequired": "Будь ласка, введіть адресу електронної пошти",
        "userEmailInvalid": "Будь ласка, введіть правильну електронну адресу",
        "emailCodeRequired": "Будь ласка, введіть код перевірки",
        "newPasswordInputLabel": "Будь ласка, введіть новий пароль",
        "confirmPasswordInputLabel": "Будь ласка, введіть пароль знову",
        "passwordMismatchErrorLabel": "Введення пароля двічі не послідовно",
        "agreementRequired": "Будь ласка, прочитайте та погодьтеся з угодою",
        "tip": "Порада",
        "tipAlreadyLogin": "Виявив, що ви ввійшли до вас і перейшли до центру користувача для вас",
        "tipWelcomeBack": "Ласкаво просимо назад ~",
        "tipDeleteAccountFail": "Видалення облікового запису не вдалося, видалення інтерфейсу облікового запису тимчасово закрито",
        "pleaseAgreeFirst": "Будь ласка, спочатку погодитися",
        "agree": "Погоджується",
        "refuse": "відмова",
        "tipNeedLogin": "Будь ласка, ввійдіть спочатку",
        "tipChangePasswordSuccess": "Успішно змінювати пароль, щоб перейти на сторінку входу для вас",
        "tipGetUserInfoSuccess": "Отримання успішної інформації",
        "tipGetUserInfoFail": "Невдалося отримати інформацію",
        "tipLoginOut": "Вихід з входу",
        "delete": "видалення",
        "back": "повернутися",
        "init": "ініціалізація",

        "passwordInputLengthErrorLabel": "Довжина пароля повинна бути від 6 до 20",
        "changePasswordFail": "Оригінальна помилка пароля",
        "tipDeleteAccountSuccess": "Видалення рахунку успішно",
        "emailCodeSentSuccess": "Код перевірки був випущений",
        "emailCodeSentFail": "Код перевірки не видав",
        "emailLoginFail": "Код перевірки закінчився",
        "passwordLoginFail": "Помилка пароля входу",
        "editUserInfoSuccess": "Успішно змінювати інформацію про користувача",
        "registerSuccess": "Успішна реєстрація",
        "registerFail": "Невдалості реєстрації",
        "registerEmailExistFail": "Поштова скринька вже існує",

        "resMessageTip0": "Невідома інформація",
        "resMessageTip1": "Помилка пароля",
        "resMessageTip2": "Довжина пароля повинна бути від 6 до 20",
        "resMessageTip3": "Помилка рахунку",
        "resMessageTip4": "Код перевірки був випущений",
        "resMessageTip5": "Код перевірки не видав",
        "resMessageTip6": "Код перевірки закінчився",
        "resMessageTip7": "Помилка пароля",
        "resMessageTip8": "Пароль не може бути таким же, як старий пароль",
        "resMessageTip9": "Поштова скринька вже існує",
        "resMessageTip10": "Успішна реєстрація",
        "resMessageTip11": "Невдалості реєстрації",
        "resMessageTip12": "Успішно змінювати інформацію про користувача",
        "resMessageTip13": "Не вдалося змінити інформацію про користувача",
        "resMessageTip14": "Успіх",
        "resMessageTip15": "Невдача отримання",
        "resMessageTip16": "Успішно змінити пароль",
        "resMessageTip17": "Не вдалося змінити пароль",
        "resMessageTip18": "Успішно скинути пароль",
        "resMessageTip19": "Невдалося скинути пароль",
        "resMessageTip20": "Успішний вход",
        "resMessageTip21": "Невдалося входу",
        "resMessageTip22": "Видалити обліковий запис успішно",
        "resMessageTip23": "Не вдалося видалити обліковий запис",
        "resMessageTip24": "Код перевірки неправильний",
        "noUserInfoError": "Помилка мережі, будь ласка, знову ввійдіть"
    },
    "changePassword": {
        "newPassword": "NEW PAROL"
    },
    "deleteUser": {
        "tipDeleteUser": "На жаль, ви повинні піти. Після видалення вашого облікового запису всі ваші особисті дані зникнуть назавжди і не будуть відновлені.",
        "accountDeletionTerms": "Умова видалення рахунку"
    },
    "forgetPassword": {
        "retrievePasswordThroughEmail": "Знайдіть пароль через поштову скриньку",
        "confirmPassword": "Підтвердження пароля",
        "resettingPassword": "Стансирайте пароль",
        "resetting": "скинути"
    },
    "login": {
        "passwordLogin": "Входи до пароля",
        "verifyLogin": "Перевірте вход",
        "accountRegistration": "Реєстрація рахунку",
        "forgotPassword": "Забув пароль",
        "login": "Входи",
        "localLogin": "Локальний вход",
        "loginOut": "Виход",
        "continueOnYourWay": "Продовжуйте"
    },
    "register": {
        "registerAnAccount": "Зареєстрований рахунок",
        "register": "Реєстрація"
    },
    "userCenter": {
        "personalInformation": "Персональна інформація",
        "modifyInformation": "Змінити інформацію",
        "changePassword": "Змінити пароль",
        "cancelAccount": "Скасування рахунку",
        "exitAccount": "Вийти з рахунку",
        "change": "Модифікація",
        "maxCharLimitTip": "Довжина імені користувача не може перевищувати 10 китайських символів",
    },
    "policies": {
        "deleteAccountPrivacy": "Видаліть угоду про рахунок",
        "agreement": "Протокол використання",
        "privacyPolicy": "Політика конфіденційності"
    },
    "api": {},
    "errorMsg": {},
    "area": {
        "regionalSelection": "Виберіть свою країну або регіон",
        "recommendedVisits": "Рекомендований доступ",
        "NorthAmerica": "Північна Америка",
        "Europe": "Європа",
        "Asia": "Азія",
        "Other": "Інші",
    }
}
export const aAndL ={
    "ar": {
        "Country": "Арабська",
        "Language": "арабська"
    },
    "cs": {
        "Country": "Чеська Республіка",
        "Language": "чеська"
    },
    "de": {
        "Country": "Німеччина",
        "Language": "німецька"
    },
    "en": {
        "Country": "Великобританія",
        "Language": "англійська мова"
    },
    "es": {
        "Country": "Іспанія",
        "Language": "Іспанська"
    },
    "fr": {
        "Country": "Франція",
        "Language": "французька"
    },
    "he": {
        "Country": "Ізраїль",
        "Language": "Єврейська"
    },
    "hu": {
        "Country": "Угорщина",
        "Language": "Угорська"
    },
    "it": {
        "Country": "Італія",
        "Language": "Італійська"
    },
    "ja": {
        "Country": "Японія",
        "Language": "японська"
    },
    "ko": {
        "Country": "Південна Корея",
        "Language": "корейська"
    },
    "nl": {
        "Country": "Нідерланди",
        "Language": "голландська"
    },
    "pt": {
        "Country": "Португалія",
        "Language": "Португальська"
    },
    "pt_BR": {
        "Country": "Португалія (Бразилія)",
        "Language": "Португальська (Бразилія)"
    },
    "ru": {
        "Country": "Росія",
        "Language": "російська"
    },
    "sv": {
        "Country": "Швеція",
        "Language": "шведська"
    },
    "tr": {
        "Country": "Туреччина",
        "Language": "Турецька"
    },
    "uk": {
        "Country": "Україна",
        "Language": "Українська мова"
    },
    "zh": {
        "Country": "Китай",
        "Language": "Спрощений китайський"
    },
    "zh_tw": {
        "Country": "Тайвань, Китай",
        "Language": "Традиційна китайська"
    },
    "Canada": {
        "Country": "Канада",
        "Language": "англійська мова"
    },
    "United_States": {
        "Country": "США",
        "Language": "англійська мова"
    },
    "United_Kingdom": {
        "Country": "Великобританія",
        "Language": "англійська мова"
    },
    "EU_Countries": {
        "Country": "Країни ЄС",
        "Language": "англійська мова"
    },
    "Australia": {
        "Country": "Австралія",
        "Language": "англійська мова"
    },
    "globalzh": {
        "Country": "Глобальний",
        "Language": "Спрощений китайський"
    },
    "globalen": {
        "Country": "Global",
        "Language": "англійська мова"
    }
}



// WEBPACK FOOTER //
// ./src/i18n/lan/uk.js